/**
 * What "Clone a repository" clones when the source is not GitHub (card
 * 89628bd6, 04.10.2026): a GitLab account (gitlab.com or self-managed), a
 * Gitea account (07.10.2026) or
 * "Other git server" with a Vault sign-in. GitHub keeps parseGitHubRepo.
 */
import { getProvider } from './providers';
import { normalizeRemoteUrl, ownerRepoOf } from './providers/remote';

const GITLAB_COM = 'https://gitlab.com';

/**
 * @param {string} input - "group/project", a URL on the account's server, or (other server) any git URL
 * @param {{ provider: string, server?: string }} source
 * @returns {{ owner: string, repo: string, url: string }} — throws with a readable message
 */
export function cloneTarget(input, source) {
  const provider = source?.provider;
  if (provider === 'remote') {
    // Same rules as Connect: https / ssh:// / git@host:, never a password in the URL.
    const url = normalizeRemoteUrl(input);
    return { ...ownerRepoOf(url), url };
  }
  if (provider === 'gitlab') {
    const server = (source.server || GITLAB_COM).replace(/\/+$/, '');
    const ref = getProvider('gitlab').parseRepo(input, server);
    if (!ref) throw new Error(`Enter the project as "group/project" or a ${server.replace(/^https?:\/\//, '')} URL.`);
    return ref;
  }
  // Gitea / Forgejo / Codeberg (07.10.2026): owner/repository on the account's server.
  if (provider === 'gitea' && source.server) {
    const server = source.server.replace(/\/+$/, '');
    const ref = getProvider('gitea').parseRepo(input, server);
    if (!ref) throw new Error(`Enter the repository as "owner/repository" or a ${server.replace(/^https?:\/\//, '')} URL.`);
    return ref;
  }
  throw new Error(`Cloning from "${provider || 'this source'}" is not supported.`);
}
